import { useEffect } from 'react';

interface SeoOptions {
  title: string;
  description?: string;
  keywords?: string;
}

function upsertMeta(name: string, content: string) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export default function useSeo({ title, description, keywords }: SeoOptions) {
  useEffect(() => {
    document.title = title;
    if (description) upsertMeta('description', description);
    if (keywords) upsertMeta('keywords', keywords);
  }, [title, description, keywords]);
}